import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import useSeo from '@/hooks/useSeo';

const HERO_IMAGE = 'https://readdy.ai/api/search-image?query=Extremely%20realistic%20professional%20industrial%20photography%20modern%20clean%20organized%20heavy%20industrial%20workshop%20with%20large%20machinery%20hydraulic%20equipment%20steel%20components%20metallic%20surfaces%20professional%20technicians%20in%20safety%20gear%20working%20not%20facing%20camera%20cinematic%20dramatic%20lighting%20gray%20silver%20steel%20tones%20with%20subtle%20warm%20yellow%20accent%20details%20wide%20angle%20widescreen%20composition%20premium%20high%20resolution%20sharp%20depth%20industrial%20maintenance%20engineering%20reliability%20heavy%20mechanics%20pulp%20paper%20mining%20oil%20gas%20sectors%20negative%20space%20for%20title%20overlay%20clean%20backgrounds%20not%20stock%20photo%20not%20illustration%20not%203D%20render&width=1600&height=700&seq=gp-cases-unified-hero-v2&orientation=landscape';
const INSPECAO_ACOPLAMENTO = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/65858ca7-a29d-40af-a445-223e968d0892_compressed_INSPECAO-ACOPLAMENTO.webp';
const MOLA_ANTIGA = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/166bab4b-2715-43b7-bf72-ba38a804a507_compressed_MOLA-ANTIGA.webp';
const MOLA_NOVA = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/61f6c6e0-8c9a-4393-91e8-3daeae189ee3_compressed_MOLA-ANTIVIBRACAO-NOVA.webp';
const PREPARACAO_MANCAL = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/9aae5e98-0912-49dc-945c-3f67720890ad_compressed_PREPARACAO-MANCAL-ROLAMENTO.webp';
const MONTAGEM_MANCAL = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/4d618977-09e5-4509-a291-6ee643e3f65a_compressed_MONTAGEM-MANCAL.webp';
const AJUSTE_ROLAMENTO = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/06ddfab6-05c7-4856-8a53-25c886dfbae5_compressed_AJUSTE-ROLAMENTO.webp';
const AJUSTE_ACOPLAMENTO = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/ca9fe0e4-5b9a-41ce-abb3-566ccfb75411_compressed_AJUSTE-ACOPLAMENTO.webp';
const ALINHAMENTO = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/8ca3cde1-1866-4e56-bc4b-663161342e3e_compressed_ALINHAMENTO-VENTILADOR2.webp';
const MOLA_SUBSTITUIDA = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/1e1814a8-815b-493b-8847-078120eb810c_compressed_MOLA-SUBSTITIUDA.webp';
const MOLA_SUBSTITUIDA2 = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/30845236-fafd-4d08-8ef2-370342015021_compressed_MOLA-SUBSTITUIDA2.webp';

export default function CaseSubstituicaoMolasAntivibracaoGncdPage() {
  useSeo({
    title: 'Substituição de Molas Antivibração em Ventilador Industrial | Case Pilar',
    description: 'Conheça como a Pilar executou a substituição das molas antivibração, inspeção de mancais, troca de rolamentos e alinhamento de ventilador GNCD durante uma Parada Geral em indústria de papel e celulose.',
    keywords: 'ventilador industrial, ventilador GNCD, molas antivibração, substituição de rolamentos, inspeção de mancais, alinhamento de equipamentos rotativos, manutenção mecânica industrial, parada geral, papel e celulose, Grupo Pilar, Aracruz, ES',
    canonical: 'https://www.pilarmanutencao.com.br/cases/substituicao-molas-antivibracao-ventilador-gncd',
    ogUrl: 'https://www.pilarmanutencao.com.br/cases/substituicao-molas-antivibracao-ventilador-gncd',
    ogImage: HERO_IMAGE,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gp-graphite">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative min-h-[60vh] flex items-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src={HERO_IMAGE}
              alt="Substituição das molas antivibração realizada para restabelecimento da estabilidade operacional do ventilador GNCD"
              title="Substituição de Molas Antivibração — Ventilador GNCD"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gp-graphite/75"></div>
          </div>
          <div className="relative z-10 w-full px-4 sm:px-6 lg:px-12 pt-28 pb-16">
            <div className="max-w-4xl">
              <div className="flex items-center gap-3 mb-6 flex-wrap">
                <span className="inline-block px-3 py-1 rounded-sm text-xs font-semibold uppercase tracking-wider bg-gp-blue text-white">
                  Serviços de Campo
                </span>
                <span className="text-gray-400 text-xs uppercase tracking-wider">Papel e Celulose</span>
                <span className="text-gray-500 text-xs">— Aracruz, ES</span>
              </div>
              <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white uppercase leading-tight mb-6">
                <span className="text-gp-yellow">Case:</span>{' '}
                Substituição de Molas Antivibração e Recuperação Mecânica de Ventilador GNCD
              </h1>
              <p className="text-gray-300 text-lg max-w-2xl leading-relaxed">
                Substituição das molas antivibração, inspeção de mancais, troca de rolamentos e alinhamento mecânico de ventilador GNCD durante Parada Geral em indústria de papel e celulose, com acesso em estrutura elevada e planejamento detalhado da intervenção.
              </p>
            </div>
          </div>
        </section>

        {/* Visão Geral */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <div
              className="absolute top-0 left-0 w-full h-full"
              style={{
                backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.15) 1px, transparent 0)',
                backgroundSize: '40px 40px',
              }}
            ></div>
          </div>
          <div className="relative z-10 px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Visão Geral</h2>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                <div className="bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-6 md:p-8">
                  <div className="flex items-start gap-4 mb-6">
                    <div className="w-12 h-12 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-information-line text-gp-yellow text-xl w-6 h-6 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <h3 className="font-display text-lg font-bold text-white uppercase mb-2">Dados do Projeto</h3>
                    </div>
                  </div>
                  <div className="space-y-3">
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-settings-3-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Equipamento</span>
                        <p className="text-gray-300 text-sm">Ventilador GNCD</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-team-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Equipe</span>
                        <p className="text-gray-300 text-sm">Equipe especializada de manutenção mecânica industrial</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-calendar-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Período</span>
                        <p className="text-gray-300 text-sm">Parada Geral</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-building-2-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Segmento</span>
                        <p className="text-gray-300 text-sm">Papel e Celulose</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="rounded-lg overflow-hidden border border-gp-graphite-lighter">
                  <div className="h-72 md:h-80 flex items-center justify-center bg-gp-graphite">
                    <img
                      src={INSPECAO_ACOPLAMENTO}
                      alt="Inspeção técnica dos componentes mecânicos e avaliação das condições operacionais do conjunto"
                      title="Inspeção técnica dos componentes mecânicos do ventilador GNCD"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="bg-gp-graphite-light p-3 border-t border-gp-graphite-lighter">
                    <p className="text-gray-400 text-xs text-center">
                      Inspeção técnica dos componentes mecânicos e avaliação das condições operacionais do conjunto.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Importância Operacional */}
        <section className="relative py-16 bg-gp-graphite-light border-t border-gp-graphite-lighter border-b border-gp-graphite-lighter">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-start gap-4 bg-gp-graphite border border-gp-yellow/20 rounded-lg p-6 md:p-8">
                <div className="w-12 h-12 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-star-line text-gp-yellow text-xl w-6 h-6 flex items-center justify-center"></i>
                </div>
                <div>
                  <h3 className="font-display text-lg font-bold text-white uppercase mb-3">Importância Operacional</h3>
                  <p className="text-gray-300 text-sm leading-relaxed">
                    O ventilador GNCD é um equipamento de elevada criticidade operacional, exigindo elevados padrões de confiabilidade para manter o desempenho adequado do sistema industrial. A atividade foi planejada para garantir o retorno seguro do equipamento à operação dentro da janela da Parada Geral.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Desafio da Intervenção */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <div
              className="absolute top-0 left-0 w-full h-full"
              style={{
                backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.15) 1px, transparent 0)',
                backgroundSize: '40px 40px',
              }}
            ></div>
          </div>
          <div className="relative z-10 px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Desafio da Intervenção</h2>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                <div className="bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-6 md:p-8">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-alert-line text-gp-yellow text-xl w-6 h-6 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <p className="text-gray-300 text-base leading-relaxed mb-4">
                        O ventilador GNCD é um equipamento rotativo crítico para o processo industrial, instalado em estrutura elevada com acessos restritos. A intervenção demandava a substituição das molas antivibração responsáveis pela sustentação do conjunto, além de inspeções detalhadas nos mancais e rolamentos durante a janela da Parada Geral.
                      </p>
                      <p className="text-gray-400 text-sm leading-relaxed mb-4">
                        As principais complexidades envolviam:
                      </p>
                      <ul className="space-y-2 mb-4">
                        <li className="flex items-start gap-2 text-gray-300 text-sm">
                          <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                          <span>Equipamento crítico para o processo industrial da planta de papel e celulose</span>
                        </li>
                        <li className="flex items-start gap-2 text-gray-300 text-sm">
                          <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                          <span>Equipamento instalado em estrutura elevada com acessos complexos</span>
                        </li>
                        <li className="flex items-start gap-2 text-gray-300 text-sm">
                          <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                          <span>Movimentação de materiais, ferramentas e componentes em altura</span>
                        </li>
                        <li className="flex items-start gap-2 text-gray-300 text-sm">
                          <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                          <span>Substituição de componentes de apoio do conjunto com impacto direto na estabilidade</span>
                        </li>
                        <li className="flex items-start gap-2 text-gray-300 text-sm">
                          <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                          <span>Inspeções mecânicas detalhadas nos mancais e rolamentos com equipamento em posição elevada</span>
                        </li>
                        <li className="flex items-start gap-2 text-gray-300 text-sm">
                          <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                          <span>Ajustes de alinhamento do conjunto rotativo após substituição de componentes</span>
                        </li>
                        <li className="flex items-start gap-2 text-gray-300 text-sm">
                          <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                          <span>Cumprimento rigoroso do cronograma de parada com múltiplas atividades simultâneas</span>
                        </li>
                      </ul>
                      <p className="text-gray-300 text-sm leading-relaxed">
                        O principal desafio era executar a substituição das molas antivibração, realizar as inspeções de mancais e rolamentos, efetuar a troca dos componentes necessários e o alinhamento final — tudo com segurança, em área elevada e dentro da janela da Parada Geral.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="rounded-lg overflow-hidden border border-gp-graphite-lighter">
                  <div className="h-72 md:h-80 flex items-center justify-center bg-gp-graphite">
                    <img
                      src={MOLA_ANTIGA}
                      alt="Componentes antivibração desgastados apresentando necessidade de substituição"
                      title="Componentes antivibração desgastados do ventilador GNCD"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="bg-gp-graphite-light p-3 border-t border-gp-graphite-lighter">
                    <p className="text-gray-400 text-xs text-center">
                      Componentes antivibração desgastados apresentando necessidade de substituição.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Planejamento da Atividade */}
        <section className="relative py-20 bg-gp-graphite-light">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Planejamento da Atividade</h2>
              </div>

              <div className="rounded-lg overflow-hidden border border-gp-graphite-lighter mb-8">
                <div className="h-64 md:h-80 flex items-center justify-center bg-gp-graphite">
                  <img
                    src={MOLA_NOVA}
                    alt="Novos elementos antivibração especificados para melhoria do desempenho operacional"
                    title="Novos elementos antivibração para ventilador GNCD"
                    className="w-full h-full object-contain"
                    loading="lazy"
                  />
                </div>
                <div className="bg-gp-graphite p-3 border-t border-gp-graphite-lighter">
                  <p className="text-gray-400 text-xs text-center">
                    Novos elementos antivibração especificados para melhoria do desempenho operacional.
                  </p>
                </div>
              </div>

              <p className="text-gray-300 text-base leading-relaxed mb-6">
                A complexidade da substituição das molas antivibração do ventilador GNCD em estrutura elevada durante a Parada Geral exigiu um planejamento detalhado e antecipado. A Pilar executou as seguintes etapas preparatórias:
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex items-start gap-4 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">A</span>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold text-sm uppercase mb-1">Planejamento da Intervenção</h4>
                    <p className="text-gray-400 text-sm leading-relaxed">Definição do escopo completo da atividade, dimensionamento de recursos, elaboração de cronograma integrado à Parada Geral e análise de riscos para trabalho em altura.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">B</span>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold text-sm uppercase mb-1">Mobilização da Equipe</h4>
                    <p className="text-gray-400 text-sm leading-relaxed">Mobilização de equipe especializada de manutenção mecânica industrial com experiência em trabalho em altura e intervenções em Paradas Gerais de papel e celulose.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">C</span>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold text-sm uppercase mb-1">Acesso ao Equipamento</h4>
                    <p className="text-gray-400 text-sm leading-relaxed">Planejamento do acesso ao equipamento em estrutura elevada, definição de rotas de movimentação de ferramentas, componentes e equipe com protocolos de segurança para trabalho em altura.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">D</span>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold text-sm uppercase mb-1">Desmontagens Preparatórias</h4>
                    <p className="text-gray-400 text-sm leading-relaxed">Planejamento das desmontagens necessárias para acesso às molas antivibração, mancais e rolamentos, garantindo segurança e produtividade durante a janela da Parada Geral.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Preparação dos Componentes */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <div
              className="absolute top-0 left-0 w-full h-full"
              style={{
                backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.15) 1px, transparent 0)',
                backgroundSize: '40px 40px',
              }}
            ></div>
          </div>
          <div className="relative z-10 px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Preparação dos Componentes</h2>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                <div className="rounded-lg overflow-hidden border border-gp-yellow/20">
                  <div className="h-64 md:h-80 flex items-center justify-center bg-gp-graphite">
                    <img
                      src={PREPARACAO_MANCAL}
                      alt="Preparação dos mancais e componentes internos para montagem e recuperação"
                      title="Preparação dos mancais e componentes internos para montagem"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="bg-gp-graphite p-3 border-t border-gp-graphite-lighter">
                    <p className="text-gray-400 text-xs text-center">
                      Preparação dos mancais e componentes internos para montagem e recuperação.
                    </p>
                  </div>
                </div>

                <div className="bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-6 md:p-8">
                  <div className="flex items-start gap-4 mb-6">
                    <div className="w-12 h-12 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-tools-line text-gp-yellow text-xl w-6 h-6 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <h3 className="font-display text-lg font-bold text-white uppercase mb-2">Preparação para Montagem</h3>
                    </div>
                  </div>
                  <p className="text-gray-300 text-base leading-relaxed mb-6">
                    Antes da execução das substituições, a Pilar realizou a preparação detalhada dos mancais e componentes internos do ventilador GNCD. A etapa envolveu a desmontagem controlada, limpeza técnica, inspeção dimensional e organização de todos os componentes para montagem posterior.
                  </p>
                  <div className="space-y-3">
                    <div className="flex items-start gap-3 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-4">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-tools-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <p className="text-gray-300 text-sm leading-relaxed pt-1">Desmontagem controlada dos mancais e componentes de apoio do conjunto</p>
                    </div>
                    <div className="flex items-start gap-3 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-4">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-search-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <p className="text-gray-300 text-sm leading-relaxed pt-1">Inspeção dimensional e avaliação das condições dos componentes internos</p>
                    </div>
                    <div className="flex items-start gap-3 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-4">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-check-double-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <p className="text-gray-300 text-sm leading-relaxed pt-1">Organização e preparação dos componentes para montagem e recuperação</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Recuperação dos Mancais */}
        <section className="relative py-20 bg-gp-graphite-light">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Recuperação dos Mancais</h2>
              </div>

              <div className="rounded-lg overflow-hidden border border-gp-graphite-lighter mb-8">
                <div className="h-64 md:h-80 flex items-center justify-center bg-gp-graphite">
                  <img
                    src={MONTAGEM_MANCAL}
                    alt="Montagem dos mancais após recuperação e inspeção dimensional dos componentes"
                    title="Montagem dos mancais após recuperação"
                    className="w-full h-full object-contain"
                    loading="lazy"
                  />
                </div>
                <div className="bg-gp-graphite p-3 border-t border-gp-graphite-lighter">
                  <p className="text-gray-400 text-xs text-center">
                    Montagem dos mancais após recuperação e inspeção dimensional dos componentes.
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                <div className="bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-6 md:p-8">
                  <p className="text-gray-300 text-base leading-relaxed mb-6">
                    A recuperação dos mancais do ventilador GNCD foi executada com rigor técnico, envolvendo inspeção dimensional detalhada, verificação das condições dos alojamentos, avaliação dos componentes de apoio e montagem controlada de todos os elementos.
                  </p>
                  <div className="space-y-3">
                    <div className="flex items-start gap-3 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-4">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-ruler-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <p className="text-gray-300 text-sm leading-relaxed pt-1">Inspeção dimensional detalhada dos mancais e componentes de apoio</p>
                    </div>
                    <div className="flex items-start gap-3 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-4">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-search-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <p className="text-gray-300 text-sm leading-relaxed pt-1">Verificação das condições dos alojamentos e superfícies de contato</p>
                    </div>
                    <div className="flex items-start gap-3 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-4">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-settings-3-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <p className="text-gray-300 text-sm leading-relaxed pt-1">Montagem controlada dos mancais com ajustes de precisão</p>
                    </div>
                  </div>
                </div>

                <div className="bg-gp-graphite border border-gp-yellow/20 rounded-lg p-6 md:p-8">
                  <div className="flex items-start gap-4 mb-6">
                    <div className="w-12 h-12 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-focus-2-line text-gp-yellow text-xl w-6 h-6 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <h3 className="font-display text-lg font-bold text-white uppercase mb-2">Destaque Técnico</h3>
                    </div>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed mb-4">
                    A recuperação dos mancais envolveu a substituição das molas antivibração responsáveis pela sustentação do conjunto, além da inspeção dos mancais, substituição dos rolamentos e alinhamento mecânico do equipamento.
                  </p>
                  <p className="text-gray-400 text-xs leading-relaxed">
                    A intervenção exigiu planejamento detalhado para movimentação de ferramentas, componentes e equipe em área elevada, garantindo segurança e produtividade durante a execução.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Ajuste de Rolamentos */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <div
              className="absolute top-0 left-0 w-full h-full"
              style={{
                backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.15) 1px, transparent 0)',
                backgroundSize: '40px 40px',
              }}
            ></div>
          </div>
          <div className="relative z-10 px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Ajuste de Rolamentos</h2>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                <div className="bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-6 md:p-8">
                  <div className="flex items-start gap-4 mb-6">
                    <div className="w-12 h-12 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-settings-3-line text-gp-yellow text-xl w-6 h-6 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <h3 className="font-display text-lg font-bold text-white uppercase mb-4">Execução dos Ajustes</h3>
                    </div>
                  </div>
                  <p className="text-gray-300 text-base leading-relaxed mb-6">
                    Os ajustes de rolamentos foram executados com instrumentação de precisão para garantir a confiabilidade operacional do conjunto rotativo do ventilador GNCD. A etapa envolveu a verificação de folgas, ajustes de pré-carga e conferência do correto posicionamento dos componentes.
                  </p>
                  <div className="space-y-3">
                    <div className="flex items-start gap-3 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-4">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-ruler-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <p className="text-gray-300 text-sm leading-relaxed pt-1">Ajustes de rolamentos com instrumentação de precisão para garantir confiabilidade</p>
                    </div>
                    <div className="flex items-start gap-3 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-4">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-check-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <p className="text-gray-300 text-sm leading-relaxed pt-1">Verificação de folgas e pré-carga conforme especificação técnica do fabricante</p>
                    </div>
                    <div className="flex items-start gap-3 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-4">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-shield-check-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <p className="text-gray-300 text-sm leading-relaxed pt-1">Conferência do correto posicionamento antes da liberação para próximas etapas</p>
                    </div>
                  </div>
                </div>
                <div className="rounded-lg overflow-hidden border border-gp-graphite-lighter">
                  <div className="h-64 md:h-80 flex items-center justify-center bg-gp-graphite">
                    <img
                      src={AJUSTE_ROLAMENTO}
                      alt="Execução dos ajustes de rolamentos para garantir confiabilidade operacional"
                      title="Ajustes de rolamentos do ventilador GNCD"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="bg-gp-graphite p-3 border-t border-gp-graphite-lighter">
                    <p className="text-gray-400 text-xs text-center">
                      Execução dos ajustes de rolamentos para garantir confiabilidade operacional.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Ajuste de Acoplamento */}
        <section className="relative py-20 bg-gp-graphite-light">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Ajuste de Acoplamento</h2>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                <div className="rounded-lg overflow-hidden border border-gp-yellow/20">
                  <div className="h-64 md:h-80 flex items-center justify-center bg-gp-graphite">
                    <img
                      src={AJUSTE_ACOPLAMENTO}
                      alt="Correção e ajuste do acoplamento para restabelecimento das condições de alinhamento"
                      title="Ajuste de acoplamento do ventilador GNCD"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="bg-gp-graphite p-3 border-t border-gp-graphite-lighter">
                    <p className="text-gray-400 text-xs text-center">
                      Correção e ajuste do acoplamento para restabelecimento das condições de alinhamento.
                    </p>
                  </div>
                </div>

                <div className="bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-6 md:p-8">
                  <div className="flex items-start gap-4 mb-6">
                    <div className="w-12 h-12 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-link text-gp-yellow text-xl w-6 h-6 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <h3 className="font-display text-lg font-bold text-white uppercase mb-4">Correção do Acoplamento</h3>
                    </div>
                  </div>
                  <p className="text-gray-300 text-base leading-relaxed mb-6">
                    O ajuste do acoplamento foi executado para restabelecer as condições de alinhamento entre os conjuntos rotativos do ventilador GNCD. A correção garantiu a transmissão adequada de torque e a redução de vibrações excessivas durante a operação.
                  </p>
                  <div className="space-y-3">
                    <div className="flex items-start gap-3 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-4">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-compass-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <p className="text-gray-300 text-sm leading-relaxed pt-1">Correção e ajuste do acoplamento para restabelecimento das condições de alinhamento</p>
                    </div>
                    <div className="flex items-start gap-3 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-4">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-tools-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <p className="text-gray-300 text-sm leading-relaxed pt-1">Verificação do torque de aperto e integridade dos elementos de ligação</p>
                    </div>
                    <div className="flex items-start gap-3 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-4">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-check-double-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <p className="text-gray-300 text-sm leading-relaxed pt-1">Conferência final do alinhamento angular e paralelo entre eixos</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Alinhamento do Equipamento */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <div
              className="absolute top-0 left-0 w-full h-full"
              style={{
                backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.15) 1px, transparent 0)',
                backgroundSize: '40px 40px',
              }}
            ></div>
          </div>
          <div className="relative z-10 px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Alinhamento do Equipamento</h2>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                <div className="bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-6 md:p-8">
                  <div className="flex items-start gap-4 mb-6">
                    <div className="w-12 h-12 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-compass-line text-gp-yellow text-xl w-6 h-6 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <h3 className="font-display text-lg font-bold text-white uppercase mb-4">Execução do Alinhamento</h3>
                    </div>
                  </div>
                  <p className="text-gray-300 text-base leading-relaxed mb-6">
                    Após a substituição das molas antivibração, inspeção dos mancais e substituição dos rolamentos, a Pilar executou o alinhamento mecânico final do conjunto rotativo do ventilador GNCD, garantindo o correto posicionamento do equipamento para retorno operacional.
                  </p>
                  <div className="space-y-3">
                    <div className="flex items-start gap-3 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-4">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-ruler-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <p className="text-gray-300 text-sm leading-relaxed pt-1">Alinhamento mecânico com instrumentação de precisão após a instalação das novas molas antivibração</p>
                    </div>
                    <div className="flex items-start gap-3 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-4">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-settings-3-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <p className="text-gray-300 text-sm leading-relaxed pt-1">Verificação do correto assentamento do conjunto sobre as molas antivibração substituídas</p>
                    </div>
                    <div className="flex items-start gap-3 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-4">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-check-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <p className="text-gray-300 text-sm leading-relaxed pt-1">Inspeções finais de todos os componentes após alinhamento para liberação operacional</p>
                    </div>
                  </div>
                </div>
                <div className="rounded-lg overflow-hidden border border-gp-yellow/20">
                  <div className="h-64 md:h-80 flex items-center justify-center bg-gp-graphite">
                    <img
                      src={ALINHAMENTO}
                      alt="Alinhamento final do conjunto mecânico após conclusão dos serviços"
                      title="Alinhamento final do ventilador GNCD"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="bg-gp-graphite p-3 border-t border-gp-graphite-lighter">
                    <p className="text-gray-400 text-xs text-center">
                      Alinhamento final do conjunto mecânico após conclusão dos serviços.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Resultado Obtido */}
        <section className="relative py-20 bg-gp-graphite-light">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Resultado Obtido</h2>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start mb-8">
                <div className="rounded-lg overflow-hidden border border-gp-yellow/20">
                  <div className="h-64 md:h-80 flex items-center justify-center bg-gp-graphite">
                    <img
                      src={MOLA_SUBSTITUIDA}
                      alt="Sistema antivibração substituído e liberado para operação"
                      title="Sistema antivibração substituído — ventilador GNCD"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="bg-gp-graphite-light p-3 border-t border-gp-graphite-lighter">
                    <p className="text-gray-400 text-xs text-center">
                      Sistema antivibração substituído e liberado para operação.
                    </p>
                  </div>
                </div>
                <div className="rounded-lg overflow-hidden border border-gp-yellow/20">
                  <div className="h-64 md:h-80 flex items-center justify-center bg-gp-graphite">
                    <img
                      src={MOLA_SUBSTITUIDA2}
                      alt="Resultado final dos serviços executados com componentes instalados e ajustados"
                      title="Resultado final dos serviços — ventilador GNCD"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="bg-gp-graphite-light p-3 border-t border-gp-graphite-lighter">
                    <p className="text-gray-400 text-xs text-center">
                      Resultado final dos serviços executados com componentes instalados e ajustados.
                    </p>
                  </div>
                </div>
              </div>

              <div className="relative rounded-lg overflow-hidden border border-gp-yellow/20 bg-gp-graphite-light p-6 md:p-8">
                <div className="absolute top-0 left-0 w-1 h-full bg-gp-yellow"></div>
                <div className="flex items-start gap-4 mb-6">
                  <div className="w-12 h-12 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-trophy-line text-gp-yellow text-xl w-6 h-6 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <h3 className="font-display text-xl font-bold text-white uppercase mb-2">Resultados</h3>
                  </div>
                </div>
                <ul className="space-y-4">
                  <li className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-tools-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <span className="text-gp-yellow font-semibold text-sm">Substituição das Molas</span>
                      <p className="text-gray-400 text-sm">Substituição completa das molas antivibração do ventilador GNCD com movimentação controlada em estrutura elevada</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-search-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <span className="text-gp-yellow font-semibold text-sm">Inspeções Realizadas</span>
                      <p className="text-gray-400 text-sm">Inspeção detalhada dos mancais e rolamentos com diagnóstico técnico para tomada de decisão sobre substituição</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-settings-3-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <span className="text-gp-yellow font-semibold text-sm">Rolamentos Substituídos</span>
                      <p className="text-gray-400 text-sm">Substituição dos rolamentos conforme resultado da inspeção, garantindo confiabilidade do conjunto rotativo</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-compass-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <span className="text-gp-yellow font-semibold text-sm">Alinhamento Executado</span>
                      <p className="text-gray-400 text-sm">Alinhamento mecânico final do conjunto rotativo com instrumentação de precisão após todas as substituições</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-shield-check-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <span className="text-gp-yellow font-semibold text-sm">Segurança</span>
                      <p className="text-gray-400 text-sm">Zero acidentes durante toda a execução em área elevada com movimentação de ferramentas e componentes</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-calendar-check-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <span className="text-gp-yellow font-semibold text-sm">Prazo da Parada Geral</span>
                      <p className="text-gray-400 text-sm">Cronograma de parada cumprido com retorno seguro do ventilador GNCD à operação dentro da janela programada</p>
                    </div>
                  </li>
                </ul>
                <div className="mt-6 pt-4 border-t border-gp-graphite-lighter bg-gp-graphite/40 rounded-lg p-4">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-information-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                    </div>
                    <p className="text-gray-400 text-xs leading-relaxed">
                      Importante: A Pilar não executou recuperação do ventilador, não executou fabricação de componentes e não forneceu as molas antivibração. O escopo da Pilar concentrou-se no planejamento da atividade durante a Parada Geral, mobilização da equipe, acesso ao equipamento em estrutura elevada, desmontagens necessárias, substituição das molas antivibração, inspeção dos mancais, inspeção e substituição dos rolamentos, ajustes mecânicos, alinhamento final e inspeções para retorno operacional.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Diferenciais Técnicos da Pilar */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <div
              className="absolute top-0 left-0 w-full h-full"
              style={{
                backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.15) 1px, transparent 0)',
                backgroundSize: '40px 40px',
              }}
            ></div>
          </div>
          <div className="relative z-10 px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Diferenciais Técnicos da Pilar</h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-building-2-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">Experiência comprovada em Paradas Gerais de plantas de papel e celulose com intervenções em equipamentos rotativos críticos</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-arrow-up-down-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">Capacidade técnica em trabalho em altura com movimentação segura de ferramentas, componentes e equipe em estruturas elevadas</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-search-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">Inspeção técnica detalhada de mancais e rolamentos com diagnóstico preciso para tomada de decisão durante paradas</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-tools-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">Domínio em substituição de componentes de apoio de equipamentos rotativos, como molas antivibração e rolamentos</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-compass-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">Alinhamento mecânico de equipamentos rotativos com instrumentação de precisão após substituição de componentes</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-timer-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">Planejamento rigoroso de intervenções com cumprimento de cronograma de Paradas Gerais e janelas reduzidas</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Galeria Técnica */}
        <section className="relative py-20 bg-gp-graphite-light">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Galeria Técnica</h2>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                <div className="relative rounded-lg border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-64 md:h-72 flex items-center justify-center">
                    <img
                      src={HERO_IMAGE}
                      alt="Substituição das molas antivibração realizada para restabelecimento da estabilidade operacional do ventilador GNCD"
                      title="Substituição das molas antivibração — ventilador GNCD"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 1</span>
                  </div>
                </div>
                <div className="relative rounded-lg border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-64 md:h-72 flex items-center justify-center">
                    <img
                      src={INSPECAO_ACOPLAMENTO}
                      alt="Inspeção técnica dos componentes mecânicos e avaliação das condições operacionais do conjunto"
                      title="Inspeção técnica dos componentes mecânicos"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 2</span>
                  </div>
                </div>
                <div className="relative rounded-lg border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-64 md:h-72 flex items-center justify-center">
                    <img
                      src={MOLA_ANTIGA}
                      alt="Componentes antivibração desgastados apresentando necessidade de substituição"
                      title="Componentes antivibração desgastados"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 3</span>
                  </div>
                </div>
                <div className="relative rounded-lg border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-64 md:h-72 flex items-center justify-center">
                    <img
                      src={MOLA_NOVA}
                      alt="Novos elementos antivibração especificados para melhoria do desempenho operacional"
                      title="Novos elementos antivibração"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 4</span>
                  </div>
                </div>
                <div className="relative rounded-lg border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-64 md:h-72 flex items-center justify-center">
                    <img
                      src={PREPARACAO_MANCAL}
                      alt="Preparação dos mancais e componentes internos para montagem e recuperação"
                      title="Preparação dos mancais e componentes internos"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 5</span>
                  </div>
                </div>
                <div className="relative rounded-lg border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-64 md:h-72 flex items-center justify-center">
                    <img
                      src={MONTAGEM_MANCAL}
                      alt="Montagem dos mancais após recuperação e inspeção dimensional dos componentes"
                      title="Montagem dos mancais após recuperação"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 6</span>
                  </div>
                </div>
                <div className="relative rounded-lg border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-64 md:h-72 flex items-center justify-center">
                    <img
                      src={AJUSTE_ROLAMENTO}
                      alt="Execução dos ajustes de rolamentos para garantir confiabilidade operacional"
                      title="Ajustes de rolamentos"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 7</span>
                  </div>
                </div>
                <div className="relative rounded-lg border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-64 md:h-72 flex items-center justify-center">
                    <img
                      src={AJUSTE_ACOPLAMENTO}
                      alt="Correção e ajuste do acoplamento para restabelecimento das condições de alinhamento"
                      title="Ajuste de acoplamento"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 8</span>
                  </div>
                </div>
                <div className="relative rounded-lg border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-64 md:h-72 flex items-center justify-center">
                    <img
                      src={ALINHAMENTO}
                      alt="Alinhamento final do conjunto mecânico após conclusão dos serviços"
                      title="Alinhamento final do conjunto mecânico"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 9</span>
                  </div>
                </div>
                <div className="relative rounded-lg border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-64 md:h-72 flex items-center justify-center">
                    <img
                      src={MOLA_SUBSTITUIDA}
                      alt="Sistema antivibração substituído e liberado para operação"
                      title="Sistema antivibração substituído"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 10</span>
                  </div>
                </div>
                <div className="relative rounded-lg border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-64 md:h-72 flex items-center justify-center">
                    <img
                      src={MOLA_SUBSTITUIDA2}
                      alt="Resultado final dos serviços executados com componentes instalados e ajustados"
                      title="Resultado final dos serviços"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 11</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Serviços Relacionados */}
        <section className="relative py-16 overflow-hidden border-t border-gp-graphite-lighter">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="max-w-4xl mx-auto">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-lg font-bold text-white uppercase tracking-wider">Serviços Relacionados</h2>
              </div>
              <div className="flex flex-wrap gap-3">
                <Link
                  to="/mecanica-industrial"
                  className="inline-flex items-center gap-2 bg-gp-graphite-light border border-gp-graphite-lighter hover:border-gp-yellow/30 px-5 py-3 rounded-lg text-gray-300 hover:text-gp-yellow text-sm font-medium transition-all duration-300"
                >
                  <i className="ri-arrow-right-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                  Mecânica Industrial
                </Link>
                <Link
                  to="/servicos-de-campo"
                  className="inline-flex items-center gap-2 bg-gp-graphite-light border border-gp-graphite-lighter hover:border-gp-yellow/30 px-5 py-3 rounded-lg text-gray-300 hover:text-gp-yellow text-sm font-medium transition-all duration-300"
                >
                  <i className="ri-arrow-right-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                  Serviços de Campo
                </Link>
                <Link
                  to="/caldeiraria-solda"
                  className="inline-flex items-center gap-2 bg-gp-graphite-light border border-gp-graphite-lighter hover:border-gp-yellow/30 px-5 py-3 rounded-lg text-gray-300 hover:text-gp-yellow text-sm font-medium transition-all duration-300"
                >
                  <i className="ri-arrow-right-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                  Caldeiraria e Solda
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="relative py-20 bg-gp-graphite">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="relative rounded-xl overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-gp-yellow/20 to-gp-graphite"></div>
              <div className="absolute inset-0 bg-gp-graphite/60"></div>
              <div className="relative z-10 p-8 md:p-12 text-center">
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase mb-4">
                  Solicite uma Avaliação Técnica
                </h2>
                <p className="text-gray-300 max-w-2xl mx-auto mb-8 leading-relaxed">
                  Entre em contato com a Pilar e receba um diagnóstico especializado para sua próxima Parada Geral. Especialistas em substituição de componentes de equipamentos rotativos, inspeção de mancais e rolamentos e alinhamento mecânico em plantas de papel e celulose.
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                  <a
                    href="https://wa.me/5527993092922"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-3 bg-gp-yellow hover:bg-gp-yellow-dark text-gp-graphite px-8 py-4 rounded-full font-semibold text-sm uppercase tracking-wider transition-all duration-300 hover:scale-105 whitespace-nowrap"
                  >
                    <div className="w-10 h-10 bg-gp-graphite rounded-full flex items-center justify-center">
                      <i className="ri-whatsapp-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                    </div>
                    <span>Solicitar Orçamento</span>
                    <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center"></i>
                  </a>
                  <Link
                    to="/contato"
                    className="inline-flex items-center justify-center gap-2 border border-gray-500 hover:border-gp-yellow text-gray-300 hover:text-gp-yellow px-8 py-4 rounded-full font-semibold text-sm transition-all duration-300 whitespace-nowrap"
                  >
                    <i className="ri-mail-line text-lg w-6 h-6 flex items-center justify-center"></i>
                    Falar com Especialista
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Back to Cases */}
        <section className="py-10 border-t border-gp-graphite-lighter">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
              <Link
                to="/cases"
                className="inline-flex items-center gap-2 text-gray-400 hover:text-gp-yellow transition-colors duration-300 text-sm uppercase tracking-wider"
              >
                <i className="ri-arrow-left-line w-5 h-5 flex items-center justify-center"></i>
                Voltar para Cases
              </Link>
              <Link
                to="/"
                className="inline-flex items-center gap-2 text-gray-400 hover:text-gp-yellow transition-colors duration-300 text-sm uppercase tracking-wider"
              >
                <i className="ri-home-line w-5 h-5 flex items-center justify-center"></i>
                Voltar para Home
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />

      {/* Schema JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: 'Substituição de Molas Antivibração e Recuperação Mecânica de Ventilador GNCD | Case Grupo Pilar',
            description: 'Conheça como a Pilar executou a substituição das molas antivibração, inspeção de mancais, troca de rolamentos e alinhamento de ventilador GNCD durante uma Parada Geral em indústria de papel e celulose.',
            image: HERO_IMAGE,
            author: {
              '@type': 'Organization',
              name: 'Grupo Pilar',
              url: 'https://www.pilarmanutencao.com.br',
            },
            publisher: {
              '@type': 'Organization',
              name: 'Grupo Pilar',
              logo: {
                '@type': 'ImageObject',
                url: '/images/MARCA/LOGO-GRUPO-PILAR/LOGO-GRUPO-PILAR.png',
              },
            },
            datePublished: '2025-12-05',
            dateModified: '2026-06-23',
            mainEntityOfPage: {
              '@type': 'WebPage',
              '@id': 'https://www.pilarmanutencao.com.br/cases/substituicao-molas-antivibracao-ventilador-gncd',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'Home',
                item: 'https://www.pilarmanutencao.com.br',
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: 'Cases de Sucesso',
                item: 'https://www.pilarmanutencao.com.br/cases',
              },
              {
                '@type': 'ListItem',
                position: 3,
                name: 'Substituição de Molas Antivibração e Recuperação Mecânica de Ventilador GNCD',
                item: 'https://www.pilarmanutencao.com.br/cases/substituicao-molas-antivibracao-ventilador-gncd',
              },
            ],
          }),
        }}
      />
    </div>
  );
}